import { CommonModule, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { catchError, finalize, of, Subject, takeUntil } from 'rxjs';
import { ChangePassword } from '../../models/general/ChangePassword';
import { ToastrService } from 'ngx-toastr';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import { AuthenticationService } from '../../services/authentication.service';
import { LoadingService } from '../../services/loading.service';
import { confirmPasswordValidator, passwordValidator, whitespaceValidator } from '../../validators/ValidationService';
import { FileUploadModule } from '@iplab/ngx-file-upload';

@Component({
    selector: 'app-change-password',
    imports: [NgClass, FileUploadModule, RouterModule, ReactiveFormsModule, CommonModule],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {

    // Password Show/Hide
    isPassword1Visible: boolean = false;
    isPassword2Visible: boolean = false;
    isPassword3Visible: boolean = false;

    isToggled = false;
    frmGroup!: FormGroup;
    isSubmitted = false;
    destroy$: Subject<boolean> = new Subject<boolean>();
    userChangePass = new ChangePassword();

    togglePassword1Visibility(): void {
        this.isPassword1Visible = !this.isPassword1Visible;
    }
    togglePassword2Visibility(): void {
        this.isPassword2Visible = !this.isPassword2Visible;
    }
    togglePassword3Visibility(): void {
        this.isPassword3Visible = !this.isPassword3Visible;
    }

    constructor(public router: Router,
        private formBuilder: FormBuilder,
        public themeService: CustomizerSettingsService,
        public authService: AuthenticationService,
        private toasterService: ToastrService,
        private loadingService: LoadingService,

    ) {
        this.initialize();
    }

    public ngOnInit(): void {
        if (this.authService.isUserAuthenticated()) {
        }
    }

    public ngAfterViewInit(): void {

        this.frmGroup.controls['oldPasswordControl'].valueChanges.subscribe(value => {
            this.userChangePass.oldPassword = value;
        });

        this.frmGroup.controls['newPasswordControl'].valueChanges.subscribe(value => {
            this.userChangePass.password = value;
        });

        this.frmGroup.controls['confirmPasswordControl'].valueChanges.subscribe(value => {
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    private initialize(): void {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.isSubmitted = false;
        this.userChangePass = new ChangePassword();

        this.createForm();
    }

    private createForm(): void {
        this.frmGroup = this.formBuilder.group({
            oldPasswordControl: new FormControl('', [Validators.required, passwordValidator(), whitespaceValidator()]),
            newPasswordControl: new FormControl('', [Validators.required, passwordValidator(), whitespaceValidator]),
            confirmPasswordControl: new FormControl('', [Validators.required, passwordValidator(), whitespaceValidator]),
        },
            {
                validator: confirmPasswordValidator('newPasswordControl', 'confirmPasswordControl')
            })
    }

    get f() { return this.frmGroup.controls; }

    public toggleClass(): void {
        this.router.navigate(["/dashboard"]);
    }

    public formIsValid(): boolean {
        const isValid = this.frmGroup.controls['oldPasswordControl'].valid &&
            this.frmGroup.controls['newPasswordControl'].valid &&
            this.frmGroup.controls['confirmPasswordControl'].valid
        return isValid;
    }

    public onSave(): void {
        if (this.frmGroup.valid) {
            this.loadingService.showLoading();
            this.authService.changePassword(this.userChangePass)
                .pipe(
                    catchError((err: any) => {
                        if (err && err.error) {
                            this.isSubmitted = false;
                            if (err.error.isCustom) {
                                this.toasterService.warning(err.error.message);
                            } else {
                                this.toasterService.error('Something went wrong!');
                            }
                        } else {
                            this.isSubmitted = false;
                            this.toasterService.error('Something went wrong!');
                        }
                        this.loadingService.hideLoading();

                        return of(null);
                    }),
                    finalize(() => {
                        this.loadingService.hideLoading();
                    }),
                    takeUntil(this.destroy$))
                .subscribe(response => {
                    if (response) {
                        this.isSubmitted = false;
                        this.toasterService.success("Save successfully");
                        this.authService.logout();
                    }
                    this.loadingService.hideLoading();
                });
        }
    }


}